import { Card, Flex, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { DownloadCopy } from "../../../components/Esign/signing/DownloadCopy.tsx"
import { SignedRecordTag } from "../../Files/components/SignedRecordTag.tsx"
import {
  saveExternalDocument,
  saveExternalRecord
} from "../api/external-signatures.services.ts"
import { joinNames } from "../helpers/join-names.ts"
import type { ExternalSignature } from "../types/external-signature.types.ts"

const { Text } = Typography

/** A document signed outside EZBuild, shown so it can never be mistaken for one signed here. */
export function ExternalSignatureCard({ signature }: { signature: ExternalSignature }) {
  const { t, i18n } = useTranslation()
  const day = (value: string) =>
    new Intl.DateTimeFormat(i18n.language, { month: "short", day: "numeric", year: "numeric" }).format(
      new Date(value.length === 10 ? `${value}T12:00:00` : value)
    )

  return (
    <Card size="small" role="region" aria-label={signature.name} data-testid="external-signature">
      <Flex vertical gap="small">
        <Flex justify="space-between" align="center" wrap gap="small">
          <Flex vertical gap={0}>
            <Text strong>{signature.name}</Text>
            <Text type="secondary">
              {t("esign.external.signedBy", {
                names: joinNames(signature.signers, i18n.language),
                date: day(signature.signed_on)
              })}
            </Text>
            <Text type="secondary" className="text-xs">
              {t("esign.external.uploadedBy", {
                name: signature.uploaded_by.name,
                date: day(signature.uploaded)
              })}
            </Text>
          </Flex>
          <SignedRecordTag signedOutside />
        </Flex>
        <Flex gap="small" wrap>
          <DownloadCopy
            compact
            download={() => saveExternalDocument(signature)}
            label={t("esign.external.downloadDocument")}
          />
          <DownloadCopy
            compact
            download={() => saveExternalRecord(signature)}
            label={t("esign.external.downloadRecord")}
          />
        </Flex>
      </Flex>
    </Card>
  )
}
